import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';
import { NavService } from "../../../_services/NavService.service";


@Component({
    selector: 'app-prd_ProductList_common',
    templateUrl: './prd_ProductList_common.component.html',
    styleUrls: ['./prd_ProductList_common.component.scss']
})
export class prd_ProductList_commonComponent implements OnInit {

    static that: prd_ProductList_commonComponent;
    tableDetails: ITableModel;
    totalCount: number = 0;
    noOfPages: number = 15;
    searchValue: string = '';
    filterObj: any = {
        Status: 'All'
    };
    payload: any = {};
    @Input() Id: any;
    @Input() referenceType: any;
    @Input() headerName: any;

    @Input() shipmentModetypearray: any = [];
    @Input() parentTypearray: any = [];

    data: any = {};
    reportHeader: any = [];
    TenantId: any;
    CompanyId: any;
    userId: any;
    OrderDataArray: any = [];
    isListApiCalled: boolean;
    SOAddress: any = {};


    // FromDate: any = {
    //     formControlName: 'FromDate',
    //     dataField: 'FromDate',
    //     placeholder: 'Select FromDate'
    // };
    // ToDate: any = {
    //     formControlName: 'ToDate',
    //     dataField: 'ToDate',
    //     placeholder: 'Select ToDate'
    // };
    searchFieldDetails: any = {
        placeholder: "Search",
        type: "text",
        isSearchBox: true,
    };
    constructor(
        private router: Router,
        private _appService: appService,
        private toastr: ToastrService,
        private cookieService: CookieService,
        private decryptpipe: DecryptPipe,
        private commonService: CommonService,
        private datePipe: DatePipe,
        private _navService: NavService,
    ) {
        prd_ProductList_commonComponent.that = this;
    }

    ngOnInit() {
        this.TenantId = JSON.parse(this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
        const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
        this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
        this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
        const storedPerPage = localStorage.getItem('perPage');
        if (storedPerPage) {
            this.noOfPages = parseInt(storedPerPage, 10);
        }
        const currentDate = new Date();
        const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

        // this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
        // this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');


        this._navService.navItem$.subscribe((item) => {
            if (this.CompanyId != JSON.parse(localStorage.getItem("ChnageCompnayId")).Id) {
                this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
                const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
                this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
            }
        });
        this.initalizeForm();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['Id']) {
            this.Id = changes['Id'].currentValue;
        }
    }

    async initalizeForm() {
        this.tableDetails = {
            data: [],
            emptyDataMSg: 'Product not available',
            isColumnNameShow: true,
            columnDetails: [
                { columnName: 'Name', dataFieldName: 'ProductName' },
                { columnName: "Code", dataFieldName: 'ProductCode' },
                { columnName: "Customer Code", dataFieldName: 'CustomerCode' },
                { columnName: 'Weight', dataFieldName: 'Weight', alignType: 'right' },
                { columnName: 'Length', dataFieldName: 'Length', alignType: 'right' },
                { columnName: 'Width', dataFieldName: 'Width', alignType: 'right' },
                { columnName: 'Height', dataFieldName: 'Height', alignType: 'right' },
                { columnName: 'Price', dataFieldName: 'Price', alignType: 'right' },
                { columnName: 'Description', dataFieldName: 'ProductDescription' }
            ]
        };
    }

    getChangedValue(value, data) {
        // if (data.dataField == 'FromDate') {
        //     if (value != null) {
        //         this.data[this.FromDate.dataField] = value;
        //     }
        // }
        // if (data.dataField == 'ToDate') {
        //     if (value != null) {
        //         this.data[this.ToDate.dataField] = value;
        //     }
        // }
    }

    GetTransactionList(
        searchValue = this.searchValue,
        pageNo: number = 0,
        filterObject: any = this.filterObj,
        perPage: any = this.noOfPages,
        Id,
        CompanyId
    ) {

        Helpers.setLoading(true);

        this.payload.Start = pageNo * perPage;
        this.payload.Length = perPage;
        this.payload.SearchValue = searchValue || null;
        this.payload.UserId = this.userId;
        this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
        this.payload.ProductCategoryId = Id ? Id : this.Id;
        this.payload.TabReferenceType = this.referenceType;

        this._appService.Post("Product", "prd_getProductListCategoryWise", this.payload).subscribe((response) => {
            if (response.length) {
                this.totalCount = response[0].recordcount;

                response.forEach((item, index) => {
                    if (item.AddressToPlot) {
                        this.SOAddress[index] = item.AddressToPlot;
                    }
                });
                console.log(this.SOAddress, 'this is SO address !');
            }
            this.assignTableFields(pageNo, perPage, response);
            Helpers.setLoading(false);

        },
            (err) => {
                Helpers.setLoading(false);
                this.toastr.error("Error while fetching data", err);
            }
        );
    }

    assignTableFields(pageNo, perPage, data) {
        this.tableDetails = {
            ...this.tableDetails, paginationDetails: {
                totalItems: this.totalCount,
                itemsPerPage: perPage,
                currentPage: pageNo + 1
            },
            data: data,
        }
    }


    GetTransactionListDownload(
        searchValue = this.searchValue,
        pageNo: number = 0,
        filterObject: any = this.filterObj,
        perPage: any = this.noOfPages,
        Id,
        CompanyId
    ) {
        Helpers.setLoading(true);

        this.payload.Start = pageNo * perPage;
        this.payload.Length = this.totalCount;
        this.payload.SearchValue = searchValue || null;
        this.payload.UserId = this.userId;
        this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
        this.payload.ProductCategoryId = Id ? Id : this.Id;
        this.payload.TabReferenceType = this.referenceType;

        this._appService.Post("Product", "prd_getProductListCategoryWise_Download", this.payload).subscribe((response) => {
            this.DownloadFile(response);
            Helpers.setLoading(false);
        },
            (error) => {
                Helpers.setLoading(false);
                this.toastr.error("Error while downloading", error);
            }
        );
    }

    DownloadFile(FileContent) {
        var byteNumbers = new Array(FileContent.Content.length);
        for (var i = 0; i < FileContent.Content.length; i++) {
            byteNumbers[i] = FileContent.Content.charCodeAt(i);
        }
        var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
        let url = window.URL.createObjectURL(blob);
        $("#DownLoadFileTyreReport").attr('href', url);
        $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
        let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
        element.attributes
        element.click();
    }


    // goToDetailsPage(rowData: any) {
    //   this.router.navigateByUrl(`/so_Orders/edit/${rowData.Id}`);
    // }


}
